module.exports = __webpack_public_path__ + "img/1106a_1.2c1e81ea.jpg";